import FormattedMessage from 'I18n/components/FormattedMessage';
import { SortTableDescIcon } from 'foundations-assets/icons/components/SortTableDescIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { COMPARE_PLANS_LINK } from '../../constants/ErrorBoundaryNames';
import { withErrorBoundary } from '../../v2/components/error-boundary/withErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComparePlansLink = () => {
  const scrollToFeatureTable = () => {
    const element = document.querySelector('#feature-table');
    const fallback = document.querySelector('table');
    (element || fallback).scrollIntoView({
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    marginBlockStart: "500",
    children: [/*#__PURE__*/_jsx(Link, {
      onClick: scrollToFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "comparePlansLink"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(SortTableDescIcon, {
        size: "600",
        color: "text-interactive-default"
      })
    })]
  });
};
export default withErrorBoundary(ComparePlansLink, {
  FallbackComponent: () => null,
  errorBoundaryName: COMPARE_PLANS_LINK
});